import type { WhatIfCategoryId } from "./types";

export type WhatIfCategory = { id: WhatIfCategoryId; emoji: string; name: string };

/** Static, ordered category list — scales to 200-300 scenarios without change. */
export const WHATIF_CATEGORIES: WhatIfCategory[] = [
  { id: "space", emoji: "🌌", name: "Space & Universe" },
  { id: "earth", emoji: "🌍", name: "Earth & Nature" },
  { id: "black-holes", emoji: "🕳️", name: "Black Holes & Extreme Space" },
  { id: "humans-space", emoji: "🚀", name: "Humans in Space" },
  { id: "physics", emoji: "⚛️", name: "Physics" },
  { id: "biology", emoji: "🧬", name: "Biology & Human Body" },
  { id: "evolution", emoji: "🦖", name: "Evolution & Prehistoric Earth" },
  { id: "oceans", emoji: "🌊", name: "Oceans & Extreme Nature" },
  { id: "future-tech", emoji: "🤖", name: "Future Technology" },
  { id: "time", emoji: "⏳", name: "Time & Relativity" },
  { id: "extreme", emoji: "🤯", name: "Extreme Science" },
];

export const CATEGORY_BY_ID = new Map(WHATIF_CATEGORIES.map((c) => [c.id, c]));